<!--
 * @Author: weixiuting weixiuting@qq.com
 * @Date: 2023-09-12 10:05:29
 * @LastEditors: weixiuting weixiuting@qq.com
 * @LastEditTime: 2023-09-14 11:53:31
 * @FilePath: \plantingSubsidy_web_update\src\views\statistics-charts\insurance-statistics\components\v1\MapStatistic\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="statistic-box">
    <div class="flex">
      <p class="num-box">{{statistic.area||0}}</p>
      <p class="label-box">投保面积(万亩)</p>
    </div>
    <div class="flex">
      <p class="num-box">{{statistic.household||0}}</p>
      <p class="label-box">投保户数(户次)</p>
    </div>
  </div>

</template>
<script>
export default {
  name: 'MapStatistic',
  props: {

    // statistic: {
    //   type: Object,
    //   default: () => ({
    //     area: 0, // 总投保面积
    //     household: 0 // 总投保户数

    //   })
    // }

  },
  data () {
    return {
      statistic: {
        area: 0, // 总投保面积
        household: 0 // 总投保户数
      }

    }
  }

}
</script>
<style scoped lang="less">
.statistic-box {
  border: 1px solid rgba(38, 138, 222, 0.27);
  background: rgba(6, 99, 182, 0.2);
  padding: 0.2rem 0;
  display: flex;
  position: absolute;
  z-index: 999;
  top: 1rem;
  right: -2rem;
  border-radius: 0.2rem;
}
.flex {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-left: 1rem;
  padding-right: 1rem;
}
.flex:nth-child(1) {
  position: relative;

  &::after {
    position: absolute;
    content: "";
    height: 80%;
    top: 10%;
    right: 0;
    border-right: 1px solid rgba(185, 201, 209, 0.36);
  }
}
.num-box {
  font-size: 1.8rem;
  font-size: 'numFont';
  color: rgba(249, 253, 255, 1);
  padding: 0;
  margin: 0;
}
.label-box {
  color: rgba(184, 200, 208, 1);
  font-size: 0.8rem;
}
</style>



// WEBPACK FOOTER //
// src/views/statistics-charts/insurance-statistics/components/v1/MapStatistic/index.vue